const BADGE_STYLES = {
    PENDING:    'bg-yellow-100 text-yellow-700',
    PROCESSING: 'bg-blue-100 text-blue-700',
    PAID:       'bg-green-100 text-green-700',
    SHIPPED:    'bg-indigo-100 text-indigo-700',
    DELIVERED:  'bg-emerald-100 text-emerald-700',
    CANCELLED:  'bg-red-100 text-red-700',
    EXPIRED:    'bg-gray-100 text-gray-500',
    REFUNDED:   'bg-orange-100 text-orange-700',
    active:     'bg-green-100 text-green-700',
    inactive:   'bg-gray-100 text-gray-600',
    paid:       'bg-green-100 text-green-700',
    pending:    'bg-yellow-100 text-yellow-700',
    shipped:    'bg-indigo-100 text-indigo-700',
    verified:   'bg-green-100 text-green-700',
    unverified: 'bg-yellow-100 text-yellow-700',
    admin:      'bg-purple-100 text-purple-700',
    customer:   'bg-blue-100 text-blue-700',
    success:    'bg-green-100 text-green-700',
    error:      'bg-red-100 text-red-700',
    warning:    'bg-yellow-100 text-yellow-700',
    info:       'bg-blue-100 text-blue-700',
  };
  
  export function StatusBadge({ status, className = '' }) {
    const style = BADGE_STYLES[status] || 'bg-gray-100 text-gray-600';
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style} ${className}`}>
        {status}
      </span>
    );
  }